<template>
  <div class="vacancy-stage-title">
    <vinput
      :value="name"
      :loading="isLoading"
      :placeholder="$tr('vacancy.tests.form.name')"
      focus
      border
      @input="$emit('set-name', $event)"
    />

    <vtextarea
      :value="description"
      :loading="isLoading"
      :height="84"
      :placeholder="$tr('vacancy.tests.form.description')"
      @input="$emit('set-description', $event)"
    />
  </div>
</template>

<script>
export default {
  props: {
    // All stage names - https://git.vcv.team/vcv/vcv2/-/blob/develop/backend-api-v1/src/Entity/Interview/Stage.php
    name: {
      type: String,
      default: ''
    },

    description: {
      type: String,
      default: ''
    },

    isLoading: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.vacancy-stage-title {
  height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 30px;
}
</style>
